import React from 'react'
import Router from './router/index'
import { HashRouter, Switch } from 'react-router-dom'
import { AuthRoute } from './components'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function App() {
	return (
		<HashRouter>
			<Switch>
				<Router/>
			</Switch>
		</HashRouter>
	)
}
export default App
